import {FC, PropsWithChildren, useMemo} from "react";
import {useFormikContext} from "formik";
import {SelectorsFormsValues} from "@constructor/components/core/forms/selectors";
import {useCharacters} from "@hooks/selectors/user.selectors";
import {injectChild} from "@constructor/functions";

interface CharactersCountChildProps {
    form_characters_count: number;
}

const CharactersCount: FC<PropsWithChildren> = ({children}) => {

    const {
        values: { selected_game_server, selected_account }
    } = useFormikContext<SelectorsFormsValues>();

    const characters = useCharacters(selected_account || '', selected_game_server);
    const data = useMemo<CharactersCountChildProps>(() => ({
        form_characters_count: characters.length
    }), [characters]);

    return injectChild(data, children);
}

export default CharactersCount;